<template>
  <div class="list shad">
    <div>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div></div>
        <div style="color:gray"></div>
        <div style="color:white">
          <!-- <share-bar 
            v-if="published && publish" 
            :shareUrl="'https://cabinetmaps.com/shared/' + $route.params.userId + '/' + publicId"
            :twitterShareMessage="title + ', a shared map by ' + $route.params.userId + ' on @CabinetMaps @Blockstack'"
            ></share-bar> -->
          <share-bar 
            v-if="publicId"
            :shareUrl="'https://cabinetmaps.com/shared/' + $route.params.userId + '/' + publicId"
            :twitterShareMessage="title + ', a shared map by ' + $route.params.userId + ' on @CabinetMaps @Blockstack'"
            ></share-bar>
        </div>
      </div>
      <h1 class="mb-4">{{ title }}</h1>
      <!-- <div style="background:whitesmoke;min-height:300px;border-radius:15px" class="mb-5">
        <vue-mapbox-map id='map-container'
          :access-token='accessToken'
          :interactive='true'
          :geocoder='false'
          :lng='mapInfo.config.longitude'
          :lat='mapInfo.config.latitude'
          :zoom='mapInfo.config.zoom'
          :pitch='mapInfo.config.pitch ? mapInfo.config.pitch : 0'
          @mapbox-ready='setMap'
        ></vue-mapbox-map>
      </div>

      <div v-if='map'>
        <vue-mapbox-feature
          :map='map'
          :uid='"circle-example"'
          :layer-type='"circle"'
          :feature='pointGeom'
          :paint='circlePaint'
          :pulse='true'
        ></vue-mapbox-feature>
      </div> -->

      <MglMap 
        style="width:100%;min-height:300px;"
        class="mb-5"
        :accessToken="accessToken" 
        :mapStyle.sync="mapStyle" 
        :center.sync="mapCenter"
        :zoom.sync="mapInfo.config.zoom"
        @load="onMapLoaded"
      >
        <MglNavigationControl position="top-right"/>
        <MglGeolocateControl position="top-right" />

        <MglMarker
          v-for="(pm, index) in this.items" :key="pm.id"
          color="black"
          size="small"
          :coordinates="[pm.longitude, pm.latitude]"
          :offset="[0,0]"
        >
          <div slot="marker" style="background:black;color:white;width:30px;height:30px;border-radius:15px;padding:4px;text-align:center;font-size:1.5em" >
            <strong>{{ String.fromCharCode(index + 97).toUpperCase() }}</strong>
          </div>
          <MglPopup 
            :coordinates="[pm.longitude, pm.latitude]" 
            anchor="left" 
            :showed="false" 
            :offset="[10,0]" 
            :closeButton="false" 
            :closeOnClick="false"
          >
            <span><strong>{{ pm.title }}</strong></span>
          </MglPopup>
        </MglMarker>
      </MglMap>

      <!-- <div>{{ summary }}</div> -->
      <h3 class="mt-4 mb-4">Placemarks</h3>
      <div v-for="(item, index) in listData.items" :key="item.id" style="border: 1px solid lightgray;border-radius:15px;padding:10px" class="mb-3">
        <div style="display:flex;flex-direction:row;align-items:flex-start">
          <div style="min-width:40px;padding:10px;color:darkgray" class="mr-3">
            <h1>{{ String.fromCharCode(index + 97).toUpperCase() }}</h1>
          </div>
          <div style="display:flex;flex-direction:column;align-items:flex-start;flex-grow:1;" class="mt-0">
            <div style="color:black" class="">
              <strong>{{ item.title }}</strong>
            </div>
            <div style="color:black">
              <em>{{ item.description }}</em>
            </div>
            <div class="links-below mt-2">
              <!-- <b-dropdown no-caret text="Open in" variant="link" toggle-class="text-decoration-none" style="">
                <template v-slot:button-content>
                  <font-awesome-icon :icon="['far', 'external-link-square']" style="color:gray;margin-left:-10px;" />
                  <span style="text-align:center;color:black" class="ml-2">Open in</span>
                </template>
                <b-dropdown-item href="#">Google Maps</b-dropdown-item>
                <b-dropdown-item href="#">Apple Maps</b-dropdown-item>
              </b-dropdown> -->
              <div style="display:flex;flex-direction:column;">
                <div style="display:flex;flex-direction:row;text-align:center;justify-content:center;color:black">
                  <a target="_blank" :href="'https://www.google.com/maps/search/?api=1&query=' + item.latitude + ',' + item.longitude" style="color:black" class="mr-3">
                    <font-awesome-icon :icon="['far', 'external-link-square']" class="mr-1" />
                    <span style="color:black">Google Maps</span>
                  </a>
                  <a target="_blank" :href="'http://maps.apple.com/?ll=' + item.latitude + ',' + item.longitude" style="color:black">
                    <font-awesome-icon :icon="['far', 'external-link-square']" class="mr-1" />
                    <span style="color:black">Apple Maps</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="links-right">
          <!-- <div style="display:flex;flex-direction:row;">
            <div style="display:flex;flex-direction:column;;text-align:center;justify-content:center" class="ml-2 mr-4">
              <a target="_blank" :href="'https://www.google.com/maps/search/?api=1&query=' + item.latitude + ',' + item.longitude" style="color:gray">
                <font-awesome-icon :icon="['far', 'external-link-square']" style="font-size:28px" />
                <div style="font-size:12px;text-align:center;color:black">Google<br />Maps</div>
              </a>
            </div>
            <div style="display:flex;flex-direction:column;align-items:middle;;justify-content:center" class="mr-2">
              <a target="_blank" :href="'http://maps.apple.com/?ll=' + item.latitude + ',' + item.longitude" style="color:gray">
                <font-awesome-icon :icon="['far', 'external-link-square']" style="font-size:28px" />
                <div style="font-size:12px;text-align:center;color:black">Apple<br />Maps</div>
              </a>
            </div>
          </div> -->
            <b-dropdown no-caret dropleft text="Navigate" class="m-2" variant="link" toggle-class="text-decoration-none">
              <template v-slot:button-content variant="light">
                <font-awesome-icon :icon="['far', 'external-link-square']" style="font-size:28px;color:gray" />
                <div style="font-size:14px;text-align:center;color:black">Navigate</div>
              </template>
              <b-dropdown-item target="_blank" :href="'https://www.google.com/maps/search/?api=1&query=' + item.latitude + ',' + item.longitude">Google Maps</b-dropdown-item>
              <b-dropdown-item target="_blank" :href="'http://maps.apple.com/?ll=' + item.latitude + ',' + item.longitude">Apple Maps</b-dropdown-item>
            </b-dropdown>
          </div>
          
        </div>
      </div>
      <!-- <ul>
        <li v-for="(item) in items" :key="item.id" class="m-2">{{ item.title }}</li>
      </ul> -->
      <h3 class="mt-5 mb-4">Notes</h3>
      <div v-html="note">
      </div>
      <hr class="mt-5 mb-4" />
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div>
        </div>
        <div style="color:black">Shared by&nbsp;<strong>{{ $route.params.userId }}</strong></div>
        <div></div>
      </div>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div>
        </div>
        <div style="color:black">Like this shared map? The <b-link :to="'/'" style="color:black;font-weight:bold">Cabinet Maps</b-link> App, is free! Get your account today.</div>
        <div></div>
      </div>
      <!-- <div class="mt-5">
          <pre>{{ listData }}</pre>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapFields, mapMultiRowFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex'
// import NoteEditor from '@/components/NoteEditor'
// import EditableTitle from '@/components/EditableTitle'
// import SingleLineInput from '@/components/SingleLineInput'
// import { Person } from "blockstack";
// import { userSession } from "../userSession";
// import { EventBus } from '@/event-bus';
import store from '@/store/store'
import NProgress from 'nprogress'
import { setTimeout } from 'timers';
// import CodeEditor from '@/components/CodeEditor'
import ShareBar from '@/components/ShareBar'
import VueMapboxMap from 'vue-mapbox-map'
import VueMapboxFeature from 'vue-mapbox-feature'

import Mapbox from "mapbox-gl"
import { 
  MglMap, 
  MglNavigationControl, 
  MglGeolocateControl,
  MglPopup,
  MglMarker,
  MglScaleControl
} from "vue-mapbox"

export default {
  data() {
    return {
      // columnDefs: null,
      // rowData: null
      map: null,
      accessToken: 'pk.eyJ1Ijoic2hvbmdvbG9sbyIsImEiOiJjazBkdDQ1bW0wYXEyM2RyejB4eW02a2xwIn0.IzZDyzAlR1sHwDvnEv7ouw',
      circlePaint: {
        'circle-radius': 5,
        'circle-color': '#29434e',
        'circle-opacity': 0.5,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#29434e',
        'circle-stroke-opacity': 0.8
      },
      linePaint: {
        'line-opacity': 1,
        'line-color': '#29434e',
        'line-width': 4,
        'line-dasharray': [1, 2],
        'line-blur': 0
      },
      fillPaint: {
        'fill-opacity': 0.2,
        'fill-color': '#a00037',
      },
      mapStyle: 'mapbox://styles/mapbox/light-v10',
      popupCoordinates: [-73.98604593990484, 40.73283788336977]
    }
  },
  computed: {
    mapCenter: {
      get: function () {
        return [this.mapInfo.config.longitude, this.mapInfo.config.latitude]
      },
      set: function (newValue) {
        // console.log('newValue: ', newValue)
        this.mapInfo.config.longitude = newValue.lng
        this.mapInfo.config.latitude = newValue.lat
      }
    },
    mapboxPlacemarks() {
      var myPlacemarks = {}
      myPlacemarks.type = "FeatureCollection"
      myPlacemarks.features = []
      this.items.forEach(pm => {
        myPlacemarks.features.push({
          "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [pm.longitude, pm.latitude]
            },
            "properties": {
              "title": pm.title,
              "description": pm.description
            }
        })
      })
      return myPlacemarks
    },
    centreGeom () {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [this.lng, this.lat]
        }
      }
    },
    pointGeom () {
      // return this.bikeShelters
      return this.mapboxPlacemarks
    },
    ...mapFields([
      'listData',
      'listData.id',
      'listData.title',
      'listData.summary',
      'listData.type',
      'listData.showNote',
      'listData.note',
      'listData.createdAt',
      'listData.publish',
      'listData.publicId',
      'listData.published',
      'listData.mapInfo',
      'blockstack.user',
      'blockstack.userSession',
      'blockstack.user.username'
    ]),
    ...mapMultiRowFields(['listData.items']),
    ...mapGetters(['listsCount']),
    needsSave () {
      return this.$store.getters.needsSave
    },
    needsSave_currentList () {
      return this.$store.getters.needsSave_currentList
    },
    needsSave_lists () {
      return this.$store.getters.needsSave_lists
    },
  },
  // created() {

  //   this.$store.dispatch('setUserSession')
  //   EventBus.$on('new-clicked', this.new);
  //   EventBus.$on('save-clicked', this.save);
  //   EventBus.$on('print-clicked', this.print);
  //   // EventBus.$on('menu-clicked', this.showNewNote);
  //   EventBus.$on('delete-clicked', this.delete);
  //   EventBus.$on('switch-list', this.switchList);
  // },
  mounted() {
    // console.log("[List] mounted - checking for blockstack")
    // this.$store.dispatch('checkAndFinishSignIn')

    // if (this.userSession.isUserSignedIn()) {
    //   // console.log("user is signed in");
    //   this.$store.dispatch('setUserProperties').then(() => {
    //     this.$store.dispatch('loadLists')
    //   })
      
    // } else if (userSession.isSignInPending()) {
    //   // console.log("signinpending")
    //   this.userSession.handlePendingSignIn().then(userData => {
    //     // console.log("user pending log in finished");
    //     this.$store.dispatch('loadLists')
    //     window.location = window.location.origin
    //   });
    // } else {
    //   // console.log("No user signed in")
    //   this.$router.push('/login')
    // }

    // console.log("[List] mounted, with param: ", this.$route.params.id);
    // console.log('enabling toolbar')
    this.$store.commit('SET_ENABLETOOLBAR', false)

    // console.log('got note: ', this.note)

    // Fix Safari UI bug
    // if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    //   setTimeout(this.safariUIFix, 10);
    // }
  },
  methods: {
    // addNewItem() {
    //   this.$store.commit('ADD_NEW_ITEM')
    // },
    // updateItem(index, newValue) {
    //   this.$store.commit('UPDATE_ITEM', { index, newValue })
    //   // this.$store.dispatch('saveIfNeeded')
    // },
    // updateNote(newValue) {
    //   if (this.note != newValue) {
    //     this.$store.commit('UPDATE_NOTE', newValue)
    //   }
    // },
    // updateCode(newValue) {
    //   console.log('got update code')
    //   // if (this.code != newValue) {
    //   //   // this.$store.commit('UPDATE_CODE', newValue)
    //   // }
    // },
    // setItemFocus(index) {
    //   this.$store.commit('SET_ITEM_FOCUS', index)
    // },
    // setItemBlur(index) {
    //   this.$store.commit('SET_ITEM_BLUR', index)
    // },
    // deleteItem(index) {
    //   this.$store.commit('DELETE_ITEM', index)
    // },
    // new () {
    //   this.$router.push('/new').catch(err => {})
    // },
    // save () {
    //   // console.log('running save')
    //   this.$store.commit('SET_LIST_SAVING', true)
    //   NProgress.start()
    //   var listId = this.id
    //   var isNewList = this.createdAt === null
    //   this.$store.dispatch('save')
    //     .then(() => {
    //       if (isNewList) {
    //         this.$router.push('/recipes/' + listId)
    //       } else {
    //         // console.log('not new list, continue...')
    //       }
    //     })
    //     .finally(() => {
    //       this.$store.commit('SET_LIST_SAVING', false)
    //       NProgress.done()
    //     })
    // },
    // print () {
    //   window.print()
    //   // console.log('needsSave is :', this.$store.getters.needsSave)
    //   // console.log('needsSave_currentList is :', this.$store.getters.needsSave_currentList)
    //   // console.log('needsSave_lists: ', this.$store.getters.needsSave_lists)
    // },
    // delete () {
    //   console.log('delete')
    //   // alert('delete coming soon!')
    //   this.$store.commit('SET_LIST_DELETING', true)
    //   this.$store.dispatch('deleteCurrentList')
    //     .then(() => {
    //       // this route will generate a new list if necessary
    //       this.$store.commit('SET_LIST_DELETING', false)
    //       this.$router.push('/recipes')
    //     })
    //     .catch(() => {
    //       this.$store.commit('SET_LIST_DELETING', false)
    //     })
    // },
    // switchList (listIndex) {
    //   const listId = this.$store.state.lists[listIndex].id
    //   this.$router.push('/recipes/' + listId).catch(err => {})
    // },
    // setType(listType) {
    //   this.type=listType
    //   if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    //     setTimeout(this.safariUIFix, 10)
    //   }
    // },
    // safariUIFix() {
    //   this.addNewItem()

    //   this.$nextTick(() => {
    //     // console.log('deleting on next tick...')
    //     let index = this.items.length - 1
    //     if (this.items[index].value === "") {
    //       this.deleteItem(index)
    //     }
    //   })
    // },
    // shareMessage() {
    //   let s = this.title + ", a map on @CabinetMaps"
    //   return s
    // },
    setMap(map) {
      // console.log('setmap')
      this.map = map
      
      this.map.on('zoom', () => {
        this.mapInfo.config.zoom = this.map.getZoom()
      });

      this.map.on('moveend', () => {
        let center = this.map.getCenter()
        this.mapInfo.config.latitude = center.lat
        this.mapInfo.config.longitude = center.lng
      });
    },
    unsetMap() {
      console.log('unsetmap')
      this.map = null
    },
    onMapLoaded() {
      console.log("map loaded")
    }
  },
  beforeMount() {
    // this.columnDefs = [
    //   {headerName: 'Ingredient', field: 'ingredient', sortable: true, editable: true},
    //   {headerName: 'Amount', field: 'amount', sortable: true, editable: true},
    // ];

    // this.rowData = [
    //   {}, {}, {}
    // ];
    
    
  },
  beforeRouteEnter (routeTo, routeFrom, next) {
    // console.log('BEFORE ROUTE ENTER')
    let userId = routeTo.params.userId
    let resource = 'public/' + routeTo.params.id
    // console.log('loading public username:', userId)
    // console.log('loading public filename:', resource)
    store.dispatch('loadPublicResource', { userId, resource })
      .then(listData => {
        // console.log('loadlist - going on in router: ', listData)
        // console.log('got listData:', listData)
        if (listData != null) {
          // Double check if published
          // TODO: Fix this later to unpublish
          // if (listData.publish == false || listData.published == false) {
          //   next({ name: '404', params: { resource: 'list' } })
          //   return
          // }
          next()
          return
        } else {
          // console.log('got error loadList - null')
          next({ name: '404', params: { resource: 'list' } })
        }
      })
      .catch(error => {
        console.log('got network error loadList', error)
        next({ name: 'network-issue' })
      })
  },
  beforeRouteUpdate (routeTo, routeFrom, next) {
    // console.log('BEFORE ROUTE UPDATE')
    let filename = 'public/' + routeTo.params.id
    // console.log('loading public filename:', filename)
    store.dispatch('loadPublicResource', filename)
      .then(listData => {
        // console.log('loadlist - going on in router: ', listData)
        console.log('got listData:', listData)
        if (listData != null) {
          // Double check if published
          if (listData.publish == false || listData.published == false) {
            next({ name: '404', params: { resource: 'list' } })
            return
          }
          next()
          return
        } else {
          // console.log('got error loadList - null')
          next({ name: '404', params: { resource: 'list' } })
        }
      })
      .catch(error => {
        console.log('got network error loadList', error)
        next({ name: 'network-issue' })
      })

  },
  // beforeRouteLeave (routeTo, routeFrom, next) {
  //   console.log('BEFORE ROUTE LEAVE')
  //   store.commit('SET_SHOWTOOLBAR', false)
  //   next()
  // },
  components: {
    // NoteEditor,
    // EditableTitle,
    // SingleLineInput,
    // CodeEditor,
    // TwitterShare,
    // VueGoodshareEmail,
    ShareBar,
    'vue-mapbox-map': VueMapboxMap,
    VueMapboxFeature,
    MglMap,
    MglNavigationControl,
    MglGeolocateControl,
    MglPopup,
    MglMarker,
    MglScaleControl
  },
  metaInfo: {
    title: 'Shared Map',
    titleTemplate: '%s | @CabinetMaps, your blockchain-secured cookbook',
    htmlAttrs: {
      lang: 'en',
      amp: false
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Lexend+Deca&display=swap');
@import url('https://fonts.googleapis.com/css?family=Mansalva&display=swap');
/* @import url('https://fonts.googleapis.com/css?family=Indie+Flower&display=swap'); */
@import url("https://api.mapbox.com/mapbox-gl-js/v1.3.1/mapbox-gl.css");

#map-container {
  /* position: relative;
  top: 0;
  left: 0; */
  /* height: 500px;
  width: 500px; */
  height:100%;
  width:100%;
  min-height:300px;
  border-radius:15px;
}

/* h1 {
  font-family: 'Indie Flower', cursive;
}

h3 {
  font-family: 'Indie Flower', cursive;
} */

.links-below {
  display:block;
}

.links-right {
  display:none;
}


.list {
  background-color: white;
  border-radius: 15px;
  padding: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
  /* margin: 8px */
  margin-left: 5px;
  margin-right: 8px;
}

.shad {
  -webkit-box-shadow: 6px 6px 5px black;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  -moz-box-shadow:    6px 6px 5px black;  /* Firefox 3.5 - 3.6 */
  box-shadow:         6px 6px 5px black;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}

li {
  font-size:22px;
}
li div {
  font-size:22px;
  /* font-weight:450; */
  /* font-family: 'Lexend Deca', sans-serif; */
}

.listitem {
  /* border: 1px dotted gray; */
}

.addbutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
  background-color: whitesmoke;
}

.addbutton:hover {
  background-color: lightgray;
}

.notebutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
}

.notebutton:hover {
  background-color: whitesmoke;
}

.notebox {
  
  margin-left:-10px;
  margin-right:-10px
}

.active {
  background: green;
  border: 1px dotted blue;
  display:inline;
}

.sli:hover + .deletebutton {
  display: block
}

.deletebutton {
    background-color:transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    width:40px;
    height:100%;
    margin-left: 5px;
    /* display:none; */
    /* border:1px solid gray; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (min-width: 500px) {

    .list {
      background-color: white;
      border-radius: 15px;
      padding: 50px;
      margin: 15px
    }

    .notebox {
      margin-left: 0px
    }

    .links-below {
      display:none;
    }

    .links-right {
      display:block;
    }
}

</style>